import Skeleton from '@mui/material/Skeleton';
import ListItem from '@mui/material/ListItem';
import { classes, styles } from './utils';

export type SkeletonListItemsProps = {
  delays?: number[];
};

export default function SkeletonListItems({
  delays = [0, 0.2, 0.3],
}: SkeletonListItemsProps) {
  return (
    <>
      {delays.map((delay) => (
        <ListItem key={delay} sx={styles.listItem}>
          <Skeleton
            sx={styles.skeleton(delay)}
            className={classes.skeleton}
            variant="rectangular"
            animation="wave"
          />
        </ListItem>
      ))}
    </>
  );
}
